<template>
<div class="chapter">
<div class="inner_page">
<h1 class="book-author">Contents</h1>
<p class="toc-text" id="pro" style="margin-top:20px;"><a class="toc-link" href="#/xhtml/prologue">Prologue</a></p>
<p class="toc-text" id="ch1"><a class="toc-link" href="#/xhtml/chapter_001">1. Hunting Ghosts</a></p>
<p class="toc-text" id="ch2"><span class="toc-link" href="#/xhtml/chapter_002" title="Link target outside of Sample">2. Great Expectations</span></p>
<p class="toc-text-indent" id="ch2a"><span class="toc-link" href="#/xhtml/chapter_002a" title="Link target outside of Sample">France 1788</span></p>
<p class="toc-text" id="ch3"><span class="toc-link" href="#/xhtml/chapter_003" title="Link target outside of Sample">3. A Prick of Blood</span></p>
<p class="toc-text" id="ch4"><span class="toc-link" href="#/xhtml/chapter_004" title="Link target outside of Sample">4. The New World</span></p>
<p class="toc-text-indent" id="ch4a"><span class="toc-link" href="#/xhtml/chapter_004a" title="Link target outside of Sample">Venice 1847</span></p>
<p class="toc-text" id="ch5"><span class="toc-link" href="#/xhtml/chapter_005" title="Link target outside of Sample">5. The Fantastic Aerialists</span></p>
<p class="toc-text" id="ch6"><span class="toc-link" href="#/xhtml/chapter_006" title="Link target outside of Sample">6. A Beating Heart</span></p>
<p class="toc-text" id="ch7"><span class="toc-link" href="#/xhtml/chapter_007" title="Link target outside of Sample">7. The Island of Doctor Wells</span></p>
<p class="toc-text-indent" id="ch7a"><span class="toc-link" href="#/xhtml/chapter_007a" title="Link target outside of Sample">New Orleans 1916</span></p>
<p class="toc-text" id="ch8"><span class="toc-link" href="#/xhtml/chapter_008" title="Link target outside of Sample">8. Story of A</span></p>
<p class="toc-text" id="ch9"><span class="toc-link" href="#/xhtml/chapter_009" title="Link target outside of Sample">9. A Game of Two Halves</span></p>
<p class="toc-text-indent" id="ch9a"><span class="toc-link" href="#/xhtml/chapter_009a" title="Link target outside of Sample">New Zealand 1964</span></p>
<p class="toc-text" id="ch10"><span class="toc-link" href="#/xhtml/chapter_010" title="Link target outside of Sample">10. A Congregation of Pleasure</span></p>
<p class="toc-text" id="ch11"><span class="toc-link" href="#/xhtml/chapter_011" title="Link target outside of Sample">11. The Illustrated Woman</span></p>
<p class="toc-text-space-after" id="epi"><span class="toc-link" href="#/xhtml/epilogue" title="Link target outside of Sample">Epilogue</span></p>
<p class="toc-text" id="ack" style="margin-top:20px;"><span class="toc-link" href="#/xhtml/ack" title="Link target outside of Sample">Acknowledgements</span></p>
<p class="toc-text" id="abt"><span class="toc-link" href="#/xhtml/about_author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?0e0e446d